<template>
	<div class="pc"></div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.pc {
	width: 100%;
	height: 100%;
	background-image: url(../assets/pc_bg_360.jpg);
	background-position: center center;
	background-repeat: no-repeat;
	background-size: 100% 100%;
}
</style>